import axios from "axios";
import { getAccessToken } from "./helpers";
import { mysphereAPIURL } from "../app/auth/util/CustomConstants";

export const listPDF = async () => {
    const accessToken = await getAccessToken();
    const headers = {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`,
    };

    return await axios.get(
        `${mysphereAPIURL}/api/v1/pdf/list`,
        { headers }
    );
}

export const addPDF = async (data) => {
    const accessToken = await getAccessToken();
    const headers = {
        "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${accessToken}`,
        "user-auth-session": `${localStorage.getItem("userAuthSessionID")}`,
    };

    return await axios.post(
        `${mysphereAPIURL}/api/v1/pdf/add`,
        data,
        { headers }
    );
}

export const deletePDF = async (id) => {
    const accessToken = await getAccessToken();
    const headers = {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`,
    };

    return await axios.delete(
        `${mysphereAPIURL}/api/v1/pdf/delete/${id}`,
        { headers }
    );
}

export const listPdfAssessment = async (pdfid) => {
    const accessToken = await getAccessToken();
    const headers = {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`,
    };
    return await axios.get(
        `${mysphereAPIURL}/api/v1/pdf/assessment?pdf=${pdfid}`,
        { headers }
    );
}